@switch (guiStatus()){
  @case (guiStatuser.harAksjeeiere){
    @if (harBeholdninger()) {
    <div class="grafer">
      <div>
        <span class="tittel">{{ "Aksjonærer" | translate }}</span>
        <c3-graf [konfigurasjon]="aksjeeiereDonutKonf()" bredde="250px" hoeyde="250px"></c3-graf>
      </div>
      <div>
        <span class="tittel">{{ "Aksjeklasser" | translate }}</span>
        <c3-graf [konfigurasjon]="aksjeklasserDonutKonf()" bredde="250px" hoeyde="250px"></c3-graf>
      </div>
    </div>
    }

    <div class="tittelrad">
      <div class="venstre">
        <h2>{{ "Aksjonærer" | translate }}</h2>
        <div class="skjul">
          <mat-slide-toggle [(ngModel)]="skjulUtenBeholdning" >{{ "Skjul aksjonærer uten beholdning" | translate }}</mat-slide-toggle>
        </div>
      </div>
      <div class="handlinger">
        @if (tilgangTilNyAksjeeier()){
          <button mat-button color="primary" (click)="visNyAksjeeierDialog()">
          <mat-icon fontSet="ion-ios-plus-outline" class="mat-icon--ionic-ikon"/>
          {{ "Legg til aksjonær" | translate }}
        </button>
        }
        @if (tilgangTilRedigerBeholdning()){
            <button mat-raised-button (click)="redigerBeholdning()" color="primary">{{ "Oppdater beholdning" | translate }}</button>
        }
        <button mat-icon-button [matMenuTriggerFor]="aksjeeierbokMeny" (click)="$event.stopPropagation()" aria-label="Aksjeeierbokmeny" class="mat-medium-icon-button">
          <mat-icon class="material-symbols-fet">more_vert</mat-icon>
        </button>
        <mat-menu #aksjeeierbokMeny="matMenu">
          @if (tilgangTilNyAksjeeier()) {
            <button mat-menu-item (click)="visNyAksjeeierDialog()">
              <mat-icon>add_circle_outline</mat-icon><span>{{ "Legg til aksjonær" | translate }}</span>
            </button>
          }
          @if (tilgangTilRedigerBeholdning()) {
            <button mat-menu-item (click)="redigerBeholdning()">
              <mat-icon>edit</mat-icon><span>{{ "Oppdater beholdning" | translate }}</span>
            </button>
          }
          <button mat-menu-item (click)="lastNedAksjeeierbok()">
            <mat-icon>download</mat-icon><span>{{ "Last ned aksjeeierbok" | translate }}</span>
          </button>
          <hr>
          @if (tilgangTilAngreSisteBeholdningsoppdatering()) {
            <button mat-menu-item (click)="visAngreSisteBeholdningsoppdateringDialog()" [disabled]="!harBeholdninger()" class="meny--angre-siste-beholdningsoppdatering">
              <mat-icon fontSet="ion-ios-trash" class="mat-icon--ionic-ikon"/><span>{{ "Angre siste beholdningsoppdatering" | translate }}</span>
            </button>
          }
        </mat-menu>
      </div>
    </div>

    @if (!harBeholdninger()) {
      <tips>
        <span>{{ "Ingen beholdninger er registrert, " | translate }}</span>
        @if (tilgangTilRedigerBeholdning()) {
          <a class="registrer-første-beholdning" (click)="redigerBeholdning()">
            {{ "registrer beholdning på dine aksjonærer." | translate }}
          </a>
        }
      </tips>
    }

    <aksjeeier-liste [aksjeeiere]="aksjeeiere()"></aksjeeier-liste>
  }

  @case (guiStatuser.ingenAksjeeiere){
    <tips>
      <p>{{ "Ingen aksjonærer er registrert." | translate }}</p>
      <p>
        <span>{{ "Merk at du her må velge mellom å legge til aksjonærer manuelt eller hente fra siste tilgjengelig offisielle data fra skatteetaten."|translate}}</span><br>
        <span>{{"Dersom du velger å legge til aksjonær manuelt vil du ikke kunne hente fra skatteetaten senere." | translate }}</span>
      </p>
    </tips>
  <div class="handlinger-ingen-aksjeeiere">

    @if (tilgangTilNyAksjeeier()){
      <button mat-button color="primary" (click)="visNyAksjeeierDialog()">
        <mat-icon fontSet="ion-ios-plus-outline" class="mat-icon--ionic-ikon"/>
        {{ "Legg til aksjonær" | translate }}
      </button>
    }
    @if (tilgangTilRedigerBeholdning()){
      <button mat-raised-button (click)="importerFraSkatteetaten()" color="primary">{{ "Importer fra Skatteetaten" | translate }}</button>
    }

  </div>

  }

  @case (guiStatuser.ingenAksjeeierbok){
    <tips>
      <!--@todo dette må håndtere etter hvert..-->
      <span>{{ "Gruppen har ingen aksjeeierbok, kontakt Styreplan" | translate }}</span>
    </tips>
  }

  @default {
    <laster-data>
      {{ "Henter aksjonærer..." | translate }}
    </laster-data>
  }
}
